/**
 * @deprecated Moved to `@degreed/lxp/org/models` (PD-127134).
 * This barrel exists only to keep callers outside `apps/lxp/src/app/orgs/`
 * compiling. Update imports and delete this file once no references remain.
 */
export * from '@degreed/lxp/org/models';

// TEMP (PD-127134): side-effect marker so this 0-byte forwarding barrel doesn't
// emit an empty chunk in the production build. A plain `export const` would be
// tree-shaken away; a global write survives optimization. Remove this line when
// callers are repointed to `@degreed/lxp/org/models` and this file is deleted.
(globalThis as Record<string, unknown>)['__orgsConfigurationValueBarrel'] =
  true;
